import React from 'react';
import Header from '../components/Header';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex flex-col" data-testid="contact-page">
      <Header />
      <main className="flex-1 pt-16 lg:pt-20">
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
